import { go, html, strMap, map } from 'fxjs/es';
import { OMPCoreAtomTmplS } from '../../../Core/Atom/S/Tmpl/module/OMPCoreAtomTmplS.js';
import { OMPCoreCellTmplS } from '../../../Core/Cell/S/Tmpl/module/OMPCoreCellTmplS.js';
import { OMPProductListConstantS } from '../Constant/module/OMPProductListConstantS.js';
import { cateSelectorTitle, checkedFilterItem } from './fn.js';
import { Switch } from '../../../../../services/Marpple/client/shared/ui/atoms/Switch/Switch.ts';
import { BodyNavigation } from '@services/Marpple/client/widgets/body-navigation/body-navigation.ts';

export const sortSelector = (query) => {
  const sort_list = OMPProductListConstantS.SORT_LIST().map((data) => {
    return {
      ...data,
      checked: data.id == query.sort,
    };
  });
  const checked_sort = sort_list.find(({ checked }) => checked);
  return html`<div class="omp-product-list__sort">
    <div class="omp-product-list__checked-sort">
      <div class="omp-product-list__checked-sort-name" data-id="${checked_sort.id}">${checked_sort.name}</div>
      <span class="omp-product-list__checked-sort-triangle">${OMPCoreAtomTmplS.triangleIcon()}</span>
    </div>
    <div class="omp-product-list__sort-selector">
      ${strMap((sort) => {
        return html`
          <button
            type="button"
            class="omp-product-list__sort-item"
            data-id="${sort.id}"
            data-name="${sort.name}"
          >
            ${sort.name}
          </button>
        `;
      }, sort_list)}
    </div>
  </div>`;
};

// 과거의 유산( gnb 개편전 )
// const cateItemHtml =
//   (query, checked_cate_list) =>
//   ({ id, name }) => {
//     return html`
//       <a
//         data-id="${id}"
//         class="omp-product-list__cate-item ${id == query.cate_item_id || (!id && !query.cate_item_id)
//           ? 'omp-product-list__cate-item--checked'
//           : ''}"
//         href="/${TT.lang}/product/list/${checked_cate_list.id}?cate_item_id=${id}"
//         >${name}</a
//       >
//     `;
//   };
export const pcListBody = (bps, query = null) => {
  if (bps.length) {
    return html`<ul class="omp-product-list__list">
      ${strMap(OMPCoreCellTmplS.product, bps)}
    </ul>`;
  } else if (query?.is_biz) {
    return html`<div class="omp-product-list__no-list">
      <div class="omp-product-list__no-list-head">
        <h3 class="omp-product-list__no-list-title">${TT('product::list::list_22_1')}</h3>
        <div class="omp-product-list__no-list-content">${TT('product::list::list_22_2')}</div>
      </div>
      <a href="/biz">
        <button class="omp-product-list__no-list-btn primary">${TT('product::list::list_22_3')}</button>
      </a>
    </div>`;
  } else {
    return html`<div class="omp-product-list__no-list">
      <div class="omp-product-list__no-list-head">
        <h3 class="omp-product-list__no-list-title">${TT('product::list::list_24_1')}</h3>
        <div class="omp-product-list__no-list-content">${TT('product::list::list_24_2')}</div>
      </div>
      <button class="omp-product-list__no-list-btn omp-product-list__reset-filter-btn">
        ${TT('product::list::list_24_3')}
      </button>
    </div>`;
  }
};
export const pcList = ({ checked_cate_list, checked_filter_items, checked_cate_item, bps, query }) => {
  return html`<div class="omp-product-list">
    <div class="omp-product-list__header">
      ${new BodyNavigation({
        items: go(
          checked_cate_list._.cate_list_sub_menus,
          map((item) => {
            return {
              id: item.id,
              label: item.name,
              image: item.mp_thumbnail_url,
              link: item.link.href,
              campaignId: item.campaign_id,
            };
          }),
        ),
        root: { label: TT('omp_layout::sub_menu_all'), link: checked_cate_list.link.href },
        className: 'utm_gnb_2',
        activeId: checked_cate_item?.campaign_id || checked_cate_item?.id || -1,
      }).toHtml(true)}
      ${cateSelectorTitle({ checked_cate_list, checked_cate_item })}
      <div class="omp-product-list__flex-header-right">
        <div class="omp-product-list__cate-item-counts">
          ${TT('product::list::list_25_1', { count: bps.length })}
        </div>
        <div class="omp-product-list__cate-tools">
          ${new Switch({
            id: 'omp-product-list__is-biz-switch',
            checked: query.is_biz?.toString() === 'true',
            label: TT('product::list::list_23_1'),
            labelPosition: 'left',
          }).toHtmlSSR()}
          ${sortSelector(query)}
        </div>
      </div>
      <div
        class="omp-product-list__checked-filter-items opm-product-list-checked-filter-items"
        data-list_show="${checked_filter_items.length > 0}"
      >
        ${strMap(checkedFilterItem, checked_filter_items)}
      </div>
    </div>
    <div class="omp-product-list__body opm-product-list-bps">${pcListBody(bps, query)}</div>
  </div>`;
};
